import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  width: "256",
  height: "256",
  fill: "currentColor",
  viewBox: "0 0 200 200"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, [...(_cache[0] || (_cache[0] = [
    _createElementVNode("path", { d: "M60 36q40-6 80 0 16 12 10 42-6 32-20 52-8 10-14 0l-6-20q-10-18-20 0l-6 20q-6 10-14 0-14-20-20-52-6-30 10-42" }, null, -1)
  ]))]))
}
export default { render: render }